import React, { useEffect, useMemo, useState } from 'react';
import {
  Col,
  Row,
  Justify,
  Icon,
} from 'tea-component';
import './index.scss';
import { useIntl } from 'umi';

import CardSlot from '@/pages/intelligence/components/CardSlot';
import MentionChart from './MentionChart';
import SentimentChart from './SentimentChart';

export default function MentionsCard(props) {
  // console.log("BUG", props)
  
  const {sentimentStacked, gameType, topicMentions, topictabList, loadingNew} = props

  const { formatMessage } = useIntl();

  // const [chartData, setChartData] = useState([]);

  return (
    <div className="dbi-mentions-card">
      <CardSlot className="dbi-mobileGames-card-context dbi-mentions-card-item">
        <Justify
          className='strength-card-head'
          left={
            <div className='strength-card-title'>{formatMessage({id: 'dbi_detail_mentions_sentiment'})}</div>
          }
        />
        <Row>
          <div
            className = 
            {
              (loadingNew)
                ? 'dbi-mentions-card-loading'
                : 'dbi-mentions-card-none'
            }
          >
            <Icon size="l" type="loading" />
            &nbsp;&nbsp;&nbsp;Loading…
          </div>
          <Col span={12}>
            {
              (!loadingNew && topicMentions.length > 0 ) ? (
                <div>
                  <div>{formatMessage({id: 'dbi_detail_mentions'})}</div>
                  <MentionChart
                    chartData={topicMentions}
                    topictabList={topictabList}
                  />
                </div>
              ) : (
                <div className = "dbi-mentions-card-loading">
                  &nbsp;&nbsp;&nbsp;{formatMessage({id: 'dbi_detail_no_data_under'})}
                </div>
              )
            }
            
          </Col>
          <Col span={12}>
            {
              (!loadingNew && sentimentStacked.length > 0 && sentimentStacked) ? (
                <div>
                  <div>{formatMessage({id: 'dbi_detail_sentiment'})}</div>
                  <SentimentChart
                    mentionsList={sentimentStacked}
                    gameType={gameType}
                  />
                </div>
              ) : (
                <div className = "dbi-mentions-card-loading">
                  &nbsp;&nbsp;&nbsp;{formatMessage({id: 'dbi_detail_no_data_under'})}
                </div>
              )
            }
          </Col>
        </Row>
      </CardSlot>
    </div>
  );
}
